import { type ReactNode } from 'react';
import { type FieldErrors, type FieldPath, type FieldValues } from 'react-hook-form';
import FormGroup, { type FormGroupProps } from '../FormGroup/FormGroup';

interface ChoiceGroupProps<T extends FieldValues, P extends FieldPath<T> = FieldPath<T>> {
  name: P;
  id: string;
  formGroupProps: Omit<FormGroupProps, 'name' | 'htmlFor' | 'children'>;
  required?: boolean;
  errors?: FieldErrors<T>;
  children: ReactNode;
}

const ChoiceGroup = <T extends FieldValues, P extends FieldPath<T>>({
  name,
  id,
  required,
  formGroupProps,
  errors,
  children,
}: ChoiceGroupProps<T, P>) => (
  <FormGroup
    {...formGroupProps}
    name={name}
    htmlFor={id}
    labelTag="legend"
    required={required}
    errors={errors}
  >
    {children}
  </FormGroup>
);

export default ChoiceGroup;
